import styled from 'styled-components';
import Colors from '../../../../shared/assets/style/default/color';
import DeviceConfig from '@devices/config';
import Screen from '../../../../shared/utils/screen';
import { TRANSITION } from '../../../../shared/types/constants/animations';

interface Props {
  load: boolean;
  disableBlur: boolean;
}

const FloatingMenuListContainer = styled.div<Props>`
  backdrop-filter: ${(props) =>
    DeviceConfig.capabilities.disableBlur || props.disableBlur
      ? ''
      : `blur(${15 * Screen.widthRatio}px)`};
  background: ${(props) =>
    DeviceConfig.capabilities.disableBlur || props.disableBlur
      ? Colors['dark']
      : 'rgba(122, 122, 122, 0.35)'};
  border-radius: ${40 * Screen.widthRatio}px;
  border: ${2 * Screen.widthRatio}px solid ${Colors['border']['floatingMenu']};
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
  min-width: ${330 * Screen.widthRatio}px;
  transform-origin: bottom;
  transition: ${TRANSITION.FLOATING_MENU_LIST};
  transform: scaleY(${(props) => (props.load ? 1 : 0)});
`;

export default FloatingMenuListContainer;
